import styled from 'styled-components';
import { Heading } from 'components';
import { media } from 'style';

export default {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  Headings: styled.div`
    margin-bottom: 50px;
  `,
  Heading: styled(Heading)`
    text-align: center;
    max-width: 610px;
  `,
  ButtonContainer: styled.div`
    margin-top: 55px;
  `,
  BulletsContainer: styled.div`
    max-width: 900px;

    ${media.md`
      padding-left: 40px;
    `}
  `,
};
